var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-pc-container"
  }, [_c('div', {
    staticClass: "title-container"
  }, [_vm.checkTip() ? _c('div', {
    staticClass: "form-title"
  }, [_vm._v(" " + _vm._s(_vm.props.payload.content.tip) + " ")]) : _vm._e(), _vm.props.payload.nodeStatus == 2 ? _c('div', {
    staticClass: "form-finish-title-right"
  }, [_c('Icon', {
    staticStyle: {
      "margin": "0px 4px"
    },
    attrs: {
      "src": _vm.iconSucess
    }
  }), _c('div', {
    staticClass: "form-finish-title"
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.已提交")) + " ")])], 1) : _vm._e()]), _vm._l(_vm.props.payload.content.inputVariables, function (item, index) {
    return _c('div', {
      key: index
    }, [_c('LabelPC', {
      attrs: {
        "name": item.name,
        "is-required": item.isRequired
      }
    }), item.formType == 0 && _vm.props.payload.nodeStatus !== 2 ? _c('div', [_c('InputPC', {
      attrs: {
        "placeholder": item.placeholder,
        "variableValue": item.variableValue,
        "name": item.name,
        "isRequired": item.isRequired,
        "validator": item.isRequired == 1 && _vm.isValid(item.name),
        "isDisabled": _vm.props.payload.nodeStatus === 1
      },
      on: {
        "input-change": _vm.handleInputChange
      }
    })], 1) : item.formType == 1 && _vm.props.payload.nodeStatus !== 2 ? _c('div', [_c('RadioPC', {
      attrs: {
        "chooseItemList": item.chooseItemList,
        "name": item.name,
        "isRequired": item.isRequired,
        "validator": item.isRequired == 1 && _vm.isValid(item.name),
        "isDisabled": _vm.props.payload.nodeStatus === 1
      },
      on: {
        "input-change": _vm.handleInputChange
      }
    })], 1) : _c('div', {
      staticClass: "variable-value-container"
    }, [_vm._v(" " + _vm._s(item.variableValue == '' || item.variableValue == null ? _vm.mapValue[item.name] : item.variableValue) + " ")])], 1);
  }), _vm.props.payload.nodeStatus !== 2 ? _c('div', {
    staticClass: "button-container"
  }, [_c('div', {
    class: _vm.props.payload.nodeStatus === 1 ? 'button-disable' : 'button',
    on: {
      "click": _vm.handleSendForm
    }
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.提交")) + " ")])]) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }